import { Injectable, signal, WritableSignal } from '@angular/core';
import { HttpService, RequestTypes } from '../helper/http.service';
import { ShallowUserRecord } from '@airwallet/shared-models/auth-user-record';
import { PayoutData } from '@airwallet/shared-models/payouts';
import { Subscription } from 'rxjs';
import { Details } from '@airwallet/shared-models/details';
import { CustomerService } from '@services/customer/customer.service';
import { QueryChange } from '@dashboard_models/rtdb';
@Injectable({
    providedIn: 'root'
})
export class HomeService {
    customerDetails: WritableSignal<Details> = signal(null);
    loadingCustomerDetails: WritableSignal<boolean> = signal(true);

    constructor(
        private http: HttpService,
        private customerService: CustomerService
    ) {}

    async getNextPayoutAmount(): Promise<PayoutData> {
        return this.http.dynamicHttp('api_insights/sum_payout', RequestTypes.GET);
    }
    async fetchUserAsAdmin(): Promise<ShallowUserRecord> {
        return this.http.dynamicHttp('api_account/fetch_user', RequestTypes.GET);
    }

    /**
     * CustomerDetails are fetched on ngInit in Home.
     */
    async getCustomerDetails(uid: string): Promise<void> {
        return new Promise(resolve => {
            const customerDetailsSub: Subscription = this.customerService.readCustomerDetails(uid).subscribe(async (customerDetailsQuery: QueryChange) => {
                customerDetailsSub.unsubscribe();
                this.customerDetails.set(customerDetailsQuery.snapshot.val());
                if (!customerDetailsQuery.snapshot.child('onboarding_state').exists()) return;

                this.loadingCustomerDetails.set(false);
                return resolve();
            });
        });
    }
}
